import { Dialog } from 'vant'

Dialog.setDefaultOptions({
    messageAlign: 'left',
    width: '75%',
    confirmButtonColor: '#FF6907',
    className: 'custom-dialog',
    overlayClass: 'reset-vant-overlay',
})
